import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $findMatchingParent, $getNearestNodeOfType, mergeRegister } from "@lexical/utils";
import { $getSelection, $isRangeSelection, $isRootOrShadowRoot, COMMAND_PRIORITY_LOW, SELECTION_CHANGE_COMMAND } from "lexical";
import { $isListNode, ListNode } from "@lexical/list";
import { $isHeadingNode } from "@lexical/rich-text";
import { Box } from "../../../../Box/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { Icon } from "../../../../Icon/index.js";
import { ToolbarButton } from "../common/index.js";
import { getSelectedNode } from "../../utils/index.js";
import { blockListTypeToBlockName, useFormatElement, useIndentFormat, useList } from "./hooks/index.js";
const ListAndFormatPlugin = (t0)=>{
    const $ = c(22);
    const { align, list: listNode, indent: indentNode } = t0;
    const [editor] = useLexicalComposerContext();
    const [alignFormat, setAlignFormat] = useState("left");
    const [blockListType, setBlockListType] = useState("paragraph");
    const [format, activeFormatIcon] = useFormatElement(editor, alignFormat);
    const [list, activeListIcon] = useList(editor, blockListType);
    const [indent, indentIcon] = useIndentFormat(editor);
    let t1;
    if ($[0] !== editor) {
        t1 = ()=>{
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const node = getSelectedNode(selection);
                const parent = node.getParent();
                const currentAlignFormat = null == parent ? void 0 : parent.getFormatType();
                setAlignFormat(()=>currentAlignFormat || "left");
                const anchorNode = selection.anchor.getNode();
                let element = "root" === anchorNode.getKey() ? anchorNode : $findMatchingParent(anchorNode, _temp);
                if (null === element) element = anchorNode.getTopLevelElementOrThrow();
                const elementKey = element.getKey();
                const elementDOM = editor.getElementByKey(elementKey);
                if (null !== elementDOM) if ($isListNode(element)) {
                    const parentList = $getNearestNodeOfType(anchorNode, ListNode);
                    const type = parentList ? parentList.getListType() : element.getListType();
                    setBlockListType(()=>type);
                } else {
                    const type_0 = $isHeadingNode(element) ? element.getTag() : element.getType();
                    type_0 in blockListTypeToBlockName ? setBlockListType(()=>type_0) : setBlockListType(_temp2);
                }
            }
        };
        $[0] = editor;
        $[1] = t1;
    } else t1 = $[1];
    const updateToolbar = t1;
    let t2;
    let t3;
    if ($[2] !== editor || $[3] !== updateToolbar) {
        t2 = ()=>mergeRegister(editor.registerUpdateListener((t4)=>{
                const { editorState } = t4;
                editorState.read(()=>{
                    updateToolbar();
                });
            }), editor.registerCommand(SELECTION_CHANGE_COMMAND, ()=>{
                updateToolbar();
                return false;
            }, COMMAND_PRIORITY_LOW));
        t3 = [
            editor,
            updateToolbar
        ];
        $[2] = editor;
        $[3] = updateToolbar;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    useEffect(t2, t3);
    let t4;
    if ($[6] !== activeFormatIcon || $[7] !== align || $[8] !== format) {
        t4 = align && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: format,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t5)=>{
                const { onClick } = t5;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick,
                    tooltip: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            activeFormatIcon,
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[6] = activeFormatIcon;
        $[7] = align;
        $[8] = format;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== activeListIcon || $[11] !== list || $[12] !== listNode) {
        t5 = listNode && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: list,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t6)=>{
                const { onClick: onClick_0 } = t6;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick_0,
                    tooltip: "\u0421\u043F\u0438\u0441\u043E\u043A",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            activeListIcon,
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[10] = activeListIcon;
        $[11] = list;
        $[12] = listNode;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== indent || $[15] !== indentIcon || $[16] !== indentNode) {
        t6 = indentNode && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: indent,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t7)=>{
                const { onClick: onClick_1 } = t7;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick_1,
                    tooltip: "\u041E\u0442\u0441\u0442\u0443\u043F",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            indentIcon,
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[14] = indent;
        $[15] = indentIcon;
        $[16] = indentNode;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
};
function _temp(e) {
    const parentElem = e.getParent();
    return null !== parentElem && $isRootOrShadowRoot(parentElem);
}
function _temp2() {
    return "paragraph";
}
export { ListAndFormatPlugin };
